import { render, staticRenderFns } from "./v-dict-select.vue?vue&type=template&id=b70a724a&scoped=true&"
import script from "./v-dict-select.vue?vue&type=script&lang=js&"
export * from "./v-dict-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70a724a",
  null
  
)

export default component.exports